/*=========================================================================================
  File Name: module-outinvoice.js
  Description: OutInvoice Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-outinvoice-state';
import mutations from './module-outinvoice-mutations';
import actions from './module-outinvoice-actions';
import getters from './module-outinvoice-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
